import { useCallback, useEffect, useLayoutEffect } from "react";
import { createTheme } from "@mui/material";

import useFetch from "./useFetch";
import { useAppDispatch, useAppSelector } from "../store/store";
import { controlMode, getSiteAppConfig } from "../services/theme.service";
import { themeSliceActions } from "../store/slices/theme";
import { chatWidgetSliceActions } from "../store/slices/chatWidget";
import { tokenService } from "../services/token.service";

const useSiteApp = () => {
  const token = tokenService.hasAccessTokens();

  const { loading, sendRequest } = useFetch(getSiteAppConfig);

  const dispatch = useAppDispatch();

  const config = useAppSelector((state) => state.theme);

  const fetchSiteAppConfig = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (success) {
      // Serviço do chat antes do tema: não depende de o frontConfig ser válido.
      dispatch(
        chatWidgetSliceActions.setChatWidget({
          ticketServiceId: data.siteApp.chatTicketServiceId ?? null,
          // O modo de abertura vem do site (P3396). O serviço de tickets ainda
          // devolve uma flag de mesmo nome — é a configuração anterior e não
          // vale mais, então não entra aqui nem como fallback.
          fullScreenMode: data.siteApp.fullScreenMode ?? false,
          profile: {
            title: data.siteApp.chatTitle ?? undefined,
            subtitle: data.siteApp.chatSubtitle ?? undefined,
            botName: data.siteApp.chatBotName ?? undefined,
            logoUrl: data.siteApp.chatLogoUrl ?? undefined,
            botAvatarUrl: data.siteApp.chatBotAvatarUrl ?? undefined,
            width: data.siteApp.chatWidth ?? undefined,
            height: data.siteApp.chatHeight ?? undefined,
          },
        })
      );

      try {
        const config = JSON.parse(data.siteApp.frontConfig);

        dispatch(themeSliceActions.setTheme(config));
      } catch (error) {
        console.warn(
          "The app configuration provided is not valid.Using default configuration"
        );
      }
    }
  }, [dispatch, sendRequest]);

  const visitUserMode = localStorage.getItem("theme");

  useEffect(() => {
    if (!token && visitUserMode) {
      dispatch(
        themeSliceActions.setThemeMode(visitUserMode === "1" ? "1" : "2")
      );
    }
  }, [dispatch, token, visitUserMode]);

  useLayoutEffect(() => {
    fetchSiteAppConfig();
  }, [fetchSiteAppConfig]);

  const theme = createTheme(controlMode(config, config.mode));

  return {
    loading,
    config,
    theme,
  };
};

export default useSiteApp;
